module.exports = __webpack_public_path__ + "assets/img/img57.8790cf72.png";